export default __webpack_public_path__ + "static/media/justLimited.be3d2926.ico";